import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=784e5f3a&scoped=true&"
import script from "./txt.vue?vue&type=script&lang=js&"
export * from "./txt.vue?vue&type=script&lang=js&"
import style0 from "./txt.vue?vue&type=style&index=0&id=784e5f3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784e5f3a",
  null
  
)

export default component.exports